<template>
  <div
    class="text-xs mb-2 flex overflow-hidden"
    :class="[classes.base]"
  >
    <div
      class="flex-1 px-4 py-2"
      v-html="notice.content"
    />
    <button
      v-if="notice.action"
      type="button"
      class="px-4 font-bold hover:text-black transition-all transition-normal"
      :class="[classes.action]"
      @click="action"
    >
      {{ notice.action.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ProjectNoticeItem',
  props: {
    notice: {
      type: Object,
      required: true
    }
  },
  computed: {
    classes() {
      let noticeStyle = {
        base: '',
        action: ''
      };
      switch(this.notice.type) {
        case 'neutral':
          noticeStyle.base = 'bg-neutral-100 text-neutral-800'
          noticeStyle.action = 'bg-neutral-300 text-neutral-900 hover:bg-neutral-600' 
          break;
        case 'positive':
          noticeStyle.base = 'bg-positive-100 text-positive-800'
          noticeStyle.action = 'bg-positive-300 text-positive-900 hover:bg-positive-600' 
          break;
        case 'negative':
          noticeStyle.base = 'bg-negative-100 text-negative-800'
          noticeStyle.action = 'bg-negative-300 text-negative-900 hover:bg-negative-600' 
          break;
        case 'primary':
          noticeStyle.base = 'bg-primary-100 text-primary-800'
          noticeStyle.action = 'bg-primary-300 text-primary-900 hover:bg-primary-600' 
          break;
        case 'grey':
          noticeStyle.base = 'bg-grey-100 text-grey-800'
          noticeStyle.action = 'bg-grey-300 text-grey-900 hover:bg-grey-600' 
          break;
      }

      return noticeStyle;
    }
  },
  methods: {
    action() {
      if(!this.notice.action) return
      return this.notice.action.method()
    }
  }
}
</script>